import './footer.css'

function NotFound() {
	return (
		<div className="not-found">
			<h1 className=' text-[70px] font-bold'>404</h1>
			
			<h1 className=' text-[70px] font-bold'>😞</h1>
			<p className="highlight">Sorry,</p>
			<p>We are busy cooking something delicious for you.</p>
			<p>Try something else. 🥘</p>
		</div>
	)
}

export default NotFound
